import { render, staticRenderFns } from "../modules/Case2.0/template/case-new-bussiness.html?vue&type=template&id=46605e0a&scoped=true&"
import script from "../modules/Case2.0/script/case-new-bussiness.ts?vue&type=script&lang=js&"
export * from "../modules/Case2.0/script/case-new-bussiness.ts?vue&type=script&lang=js&"
import style0 from "../modules/Case2.0/style/case-new-bussiness.scss?vue&type=style&index=0&id=46605e0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46605e0a",
  null
  
)

export default component.exports